const organisationSettingsModuleRouteMap = {
  kunden: 'kdb',
  mitglieder: 'fmv',
  kurse: 'ktv',
  familie: 'kifam',
  akademie: 'ls',
  aktive: 'av'
}

const moduleKeyToSlugMap = Object.fromEntries(
  Object.entries(organisationSettingsModuleRouteMap).map(([slug, moduleKey]) => [moduleKey, slug])
)

export const normalizeOrganisationSettingsModuleKey = (value) => {
  const normalizedValue = String(value || '').trim().toLowerCase()
  if (organisationSettingsModuleRouteMap[normalizedValue]) {
    return organisationSettingsModuleRouteMap[normalizedValue]
  }

  if (Object.hasOwn(moduleKeyToSlugMap, normalizedValue)) {
    return normalizedValue
  }

  return 'kdb'
}

export const getOrganisationSettingsModuleSlug = (value) => {
  const normalizedModuleKey = normalizeOrganisationSettingsModuleKey(value)
  return moduleKeyToSlugMap[normalizedModuleKey] || 'kunden'
}

